import Model from "./Model";

export default class PreMatricula extends Model {
  constructor(prematricula) {
    super();
    Object.assign(this, prematricula);
  }
}
